import { ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useDialogStore } from '@/store';

type Props = {
  id: string;
};

function ActionBtn({ id }: Props) {
  const { openRequestDialog } = useDialogStore();

  const handleClick = (e: React.MouseEvent) => {
    if (!id) return;

    // Check if Ctrl/Cmd key is pressed during click - open in new tab
    if (e.ctrlKey || e.metaKey) {
      window.open(`/purchases/one-request/${id}`, '_blank');
      return;
    }

    // Otherwise open the request in modal using Zustand store
    openRequestDialog(id);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleClick}
      title="View request details (Ctrl+Click to open in new tab)"
      className="h-7 w-7"
    >
      <ExternalLink className="h-4 w-4" />
    </Button>
  );
}

export default ActionBtn;
